export const FilterIcon = ({
  className = 'w-4 h-4',
  fill = 'currentColor',
  stroke = 'currentColor',
}: {
  className?: string;
  fill?: string;
  stroke?: string;
}) => (
  <svg
    className={className}
    fill={fill}
    stroke={stroke}
    xmlns="http://www.w3.org/2000/svg"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    imageRendering="optimizeQuality"
    fillRule="evenodd"
    clipRule="evenodd"
    viewBox="0 0 512 438.89"
  >
    <path d="M346.34 216.95c30.62 0 58.39 12.45 78.45 32.52 20.07 20.06 32.52 47.83 32.52 78.45 0 30.62-12.45 58.39-32.52 78.46-20.06 20.06-47.83 32.51-78.45 32.51-30.62 0-58.39-12.45-78.46-32.51-20.06-20.07-32.51-47.84-32.51-78.46 0-30.62 12.45-58.39 32.51-78.45 20.07-20.07 47.84-32.52 78.46-32.52zM99.44 46.99l69.16 81.05-18.67 16.01L80.77 63l18.67-16.01zm89.28 349.23h33.42c4.88 8.84 10.69 17.1 17.28 24.68h-75.38V239.95L12.1 61.85C5.95 53.8 2.27 45.92.78 38.73c-1.59-7.83-.71-15 2.33-21.1 3.17-6.3 8.42-11.18 15.44-14.22C24.35.97 31.35-.27 39.3.05L478.56.02c7.14.09 13.09 1.36 17.9 3.61 6.99 3.27 11.61 8.46 13.91 14.9 2.09 5.82 2.12 12.38.34 19.1-1.9 7.13-6.04 14.86-12.02 22.31l-111.43 132.2c-8.85-2.67-18.08-4.49-27.57-5.38L479.54 44.55c3.76-4.73 6.32-9.33 7.37-13.29.53-1.99.65-3.55.33-4.46-.09-.27-.5-.6-1.18-.92-1.67-.77-4.17-1.23-7.5-1.24H38.72c-4.38-.22-7.91.28-10.44 1.37-1.6.73-2.7 1.63-3.19 2.6-.59 1.16-.69 2.92-.25 5.12.77 3.65 2.94 8.06 6.71 13.04l154.17 180.69 3 8v160.76zm-4.47-249.84 24.45 28.66-18.68 16.01-24.45-28.66 18.68-16.01zm217 170.86v21.38c0 4.17-3.51 7.69-7.68 7.69h-28.84v28.84c0 4.19-3.52 7.7-7.7 7.7h-21.39c-4.18 0-7.7-3.47-7.7-7.7v-28.84h-28.85c-4.16 0-7.68-3.46-7.68-7.69v-21.38c0-4.25 3.45-7.71 7.68-7.71h28.85v-28.84c0-4.23 3.47-7.69 7.7-7.69h21.39c4.24 0 7.7 3.52 7.7 7.69v28.84h28.84c4.23 0 7.68 3.58 7.68 7.71z" />
  </svg>
);
